import React from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material"

import {DateTime} from "luxon"

import Icon from "@mdi/react"
import {mdiAccountOutline, mdiCheckboxMarkedCircleOutline, mdiClockTimeEightOutline, mdiSkipNext,} from "@mdi/js"

import {Action, ActionStatus,} from "models"
import {Trans} from "@lingui/macro";

export interface WorkflowActionsProps
{
    action: Action
    skipAction: (actionId: string) => void
    openAssignDialog: () => void
    openDeferDialog: () => void
    onActionSelected: () => void
    markActionAsDone: () => void
}
export interface WorkflowActionsState
{
    openSkipModal: boolean
}
export class WorkflowActions extends React.Component<WorkflowActionsProps, WorkflowActionsState>
{

    constructor(props: WorkflowActionsProps) {
        super(props);
        this.state = {
            openSkipModal: false
        }
    }

    private assignButton = () => {
        this.props.openAssignDialog()
    }

    private postponeButton = () => {
        this.props.openDeferDialog()
    }

    private doneButton = () => {
        this.props.markActionAsDone()
    }

    private openSkipModal = () => {
        this.setState(() => ({
            openSkipModal: true
        }))
    }

    private closeSkipModal = (id?: string) => {
        this.setState(() => ({
            openSkipModal: false
        }))
        if(id){
            this.props.skipAction(id)
        }
    }

    render()
    {
        return(
            <div style={{ overflowX: 'hidden' }} onClick={() => this.props.onActionSelected()}>
                <Grid container alignItems="center" sx={{ pt: 1, pb: 1 }} justifyContent={"flex-end"}>
                    <Grid item xs={6}>
                        <Stack direction="column">
                            <Typography color="#555555" sx={{ fontSize: "16px", fontWeight: '600' }}>
                                {this.props.action.name}
                            </Typography>
                            <Typography sx={{ fontSize: 10, fontWeight: '600' }}>
                                <Trans id={"workflow.assignedTo"}>
                                    Assegnato a &nbsp;
                                    {
                                        this.props.action.executor ?
                                            (
                                                (this.props.action.executor.accountDetails && this.props.action.executor.accountDetails.firstName && this.props.action.executor.accountDetails.lastName) ?
                                                    <span>{this.props.action.executor.accountDetails.firstName} {this.props.action.executor.accountDetails.lastName}</span> :
                                                    <span>{this.props.action.executor.username}</span>
                                            ) :
                                            <Trans id={"workflow-actions.unassigned"}>
                                                nessuno
                                            </Trans>
                                    }
                                </Trans>
                            </Typography>
                            {this.props.action.executionDate && this.props.action.status === ActionStatus.DONE &&
                                <Typography color="gray" sx={{ fontSize: "12px" }}>
                                    Eseguita il {DateTime.fromISO(this.props.action.executionDate).toFormat("dd MMM yyyy")}
                                </Typography>
                            }
                            {this.props.action.deadline && this.props.action.status !== ActionStatus.DONE && this.props.action.status !== ActionStatus.SKIPPED &&
                                <Typography color="gray" sx={{ fontSize: "12px" }}>
                                    Programmata per il {DateTime.fromISO(this.props.action.deadline).toFormat("dd MMM yyyy")}
                                </Typography>
                            }
                            {
                                this.props.action.status === ActionStatus.SKIPPED &&
                                <Typography color="gray" sx={{ fontSize: "12px" }}>
                                    Azione saltata
                                </Typography>
                            }
                        </Stack>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                        {(this.props.action.status !== ActionStatus.DONE && this.props.action.status !== ActionStatus.SKIPPED) &&
                            <>
                                <Tooltip title="Assegna" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="assign"
                                        onClick={this.assignButton}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiAccountOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Posticipa" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="postpone"
                                        onClick={this.postponeButton}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiClockTimeEightOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                            </>
                            // <Tooltip title="Modifica" placement="top" arrow>
                            //     <IconButton
                            //         sx={{
                            //             color: 'grey',
                            //             backgroundColor: "transparent",
                            //             ":hover": {
                            //                 color: "secondary.main"
                            //             }
                            //         }}
                            //         aria-label="edit"
                            //         // onClick={this.editAction}
                            //         disableFocusRipple
                            //         disableRipple>
                            //         <Icon path={mdiAccountOutline} size={1} />
                            //     </IconButton>
                            // </Tooltip>
                        }
                        {this.props.action.status === ActionStatus.WORKING &&
                            <>
                                <Tooltip title="Salta" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="skip"
                                        onClick={this.openSkipModal}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiSkipNext} size={1} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Eseguita" placement="top" arrow>
                                    <IconButton
                                        sx={{
                                            color: 'grey',
                                            backgroundColor: "transparent",
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        }}
                                        aria-label="Delete"
                                        onClick={this.doneButton}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiCheckboxMarkedCircleOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        }
                    </Grid>
                </Grid>
                {
                    this.state.openSkipModal &&
                    <Dialog open={this.state.openSkipModal} onClose={() => (this.closeSkipModal())}>
                        <DialogTitle>
                            <Typography variant="h5" textAlign="center">
                                <Trans id="workflow.workflow-action.skip.title">
                                    Salta azione
                                </Trans>
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography>
                                <Trans id={"workflow.workflow-action.skip"}>
                                    Sei sicuro di voler saltare l'azione? L'operazione è irreversibile.
                                </Trans>
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.closeSkipModal()}
                                    variant={"contained"}
                                    color="neutral"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                        width: 100
                                    }}
                                    disableElevation>
                                <Trans id={"workflow.workflow-action.abort"}>
                                    Annulla
                                </Trans>
                            </Button>
                            <Button onClick={() => (this.closeSkipModal(this.props.action.id))}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'secondary.main',
                                        color: 'white',
                                        mr: 1,
                                        textTransform: "none",
                                        width: 100
                                    }}
                            >
                                <Trans id={"workflow.workflow-action.confirm"}>Conferma</Trans>
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </div>
        )
    }
}
